import React, { useState, useEffect} from "react";
import {
  Checkbox,
  Flex,
  Popover,
  Radio,
  Space,
} from "antd";
import {
  CaretDownOutlined,
  OneToOneOutlined,
  SyncOutlined,
  VerticalAlignBottomOutlined,
  LoadingOutlined,
  ProfileOutlined
} from "@ant-design/icons";
import { useLocation } from "react-router-dom";
import commonFn from "@/utils/commonFn";

const CustomTableExtend = ({
  children = (<div></div>),
  extraBtnChildren = (<div></div>),
  setColumns,
  initColumns = [],
  refreshKey,
  setRefreshKey,
  noShowList = [],
  downLoadFn
}) => {
  const [selectedItems, setSelectedItems] = useState([]);
  const [options, setOptions] = useState([]);
  const [downLoadLoading, setDownLoadLoading] = useState(false);

  // 处理选项变化
  const handleChange = (checkedValues) => {
    setSelectedItems(checkedValues);
    setColumns(initColumns.map(item => ({ ...item, hidden: !checkedValues.includes(item.dataIndex) })));
  };

  const content = (
    <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
      <Checkbox.Group
        options={options}
        value={selectedItems}
        className="checkBox"
        onChange={handleChange}
      >
        {/* 使用 Space 的 direction="vertical" 来让复选框垂直排列 */}
        <Space direction="vertical">
          {options.map((option) => (
            <Checkbox key={option.value} value={option.value}>
              {option.label}
            </Checkbox>
          ))}
        </Space>
      </Checkbox.Group>
    </div>
  );

  const excelDownLoad = async() => {
    if(typeof downLoadFn !== 'function' || downLoadLoading) return
    setDownLoadLoading(true)
    const {blob, name} = await downLoadFn()
    await commonFn.getBlobExcelFn({blob, name})
    setDownLoadLoading(false)
  }

  const content2 = <a onClick={excelDownLoad}>Export to CSV</a>;

  useEffect(() => {
    const transformedList = initColumns.map((item) => ({
      label: item.title,
      value: item.dataIndex,
    }));
    setOptions(transformedList);
    const transformedList2 = initColumns.filter((item) => !item.hidden).map((item) => item.dataIndex);
    setSelectedItems(transformedList2);
  }, [refreshKey])

  const location = useLocation();

  const userUsageFn = () => {
    const path = location.pathname.split('?')?.[0]
    const params = { path };
    const route = '/UserUsage/index'
    localStorage.setItem('currentMenu', 'User Usage');
    const url = `${window.location.origin}#${route}?${new URLSearchParams(params).toString()}`;
    window.open(url, "_blank", "noopener,noreferrer");
  }

  return (
    <Flex style={{width:'100%', paddingBottom:'20px'}} justify="space-between" align="flex-start">
      { children }
      <div style={{minWidth:'180px', textAlign: 'right'}}>
        <Radio.Group defaultValue="refresh" size="middle">
          {!noShowList.includes('UserUsage') && commonFn.btnAuthorityFlag('UserUsage') && <Radio.Button value="userUsage" onClick={() => userUsageFn()}>
            {/* <ProfileOutlined /> */}
            User Usage
          </Radio.Button> || null}
          {!noShowList.includes('refresh') && <Radio.Button value="refresh" onClick={() => setRefreshKey(+new Date())}>
            <SyncOutlined />
          </Radio.Button> || null}
          {!noShowList.includes('columnList') && <Radio.Button value="columnList">
            <Popover content={content} title="" trigger="click">
              <OneToOneOutlined />
              <CaretDownOutlined style={{fontSize: '12px', marginLeft:'3px'}} />
            </Popover>
          </Radio.Button> || null}
          {!noShowList.includes('download') && <Radio.Button value="download">
            <Popover content={content2} title="" trigger="click">
              {downLoadLoading ? <LoadingOutlined /> : <VerticalAlignBottomOutlined />}
              <CaretDownOutlined style={{fontSize: '12px', marginLeft:'3px'}} />
            </Popover>
          </Radio.Button> || null}
          { extraBtnChildren }
        </Radio.Group>
      </div>
  </Flex>
  );
};

export default CustomTableExtend;